
















import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  RepositoryFactory,
  Repositories
} from '../repositories/repositoryFactory'
import { Getter } from 'vuex-class'
import VehicleType from '../models/vehicleTypeModel'
import TranslationModel from '../models/translationModel'

@Component
export default class VehicleTypes extends Vue {
  icons: Array<string> = [ 'truck', 'tractor', 'car' ]
  types: Array<VehicleType> = [];

  mounted () {
    this.$store.dispatch('fetchTypes')
      .then((types) => {
        this.types = types
      })
  }

  selectType (type: VehicleType) {
    // Break reactivity
    const chosenType = Object.assign(new VehicleType(), type)
    this.$store.dispatch('updateVehicleType', chosenType).then(() => {
      this.$router.push({ name: 'inspection', params: { step: '2' } })
    })
  }

}
